export type static_ = "static";
export type absolute = "absolute";
export type relative  = "relative";
export type fixed = "fixed";

//  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
//    $1 |

export type CSSPositionType = 
  static_ |
  absolute |
  relative |
  fixed
;

export class CSSPosition
{
  //  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
  //  static readonly $1:$1 = "$2";

  static readonly static_:static_ = "static";
  static readonly absolute:absolute = "absolute";
  static readonly relative:relative = "relative";
  static readonly fixed:fixed = "fixed";
  
}